import React from "react";
import LeadsForm from "src/components/LeadsForm";
import Modal from "src/components/UserInterface/Modal";

type LeadFormModalProps = React.ComponentPropsWithoutRef<"div"> & {
  leadFormType: "FLEXICASHLEADS" | "KMGLEADS";
  isOpen: boolean;
  onClose: () => void;
};

const LeadFormModal = (props: LeadFormModalProps) => {
  const { leadFormType, isOpen, onClose } = props;

  if (!isOpen) {
    return null;
  }

  return (
    <Modal close={onClose}>
      <LeadsForm
        description="Halo! Kami dengan senang hati akan membantu Anda mengajukan aplikasi kredit barang impian Anda! Isi data berikut dan kami akan segera menghubungi Anda."
        title="Formulir Pengajuan"
        leadFormType={leadFormType}
        valueDump={{}}
      />
    </Modal>
  );
};

export default LeadFormModal;
